import { InfoOutlined } from '@mui/icons-material'
import { Box, Container, Fade, IconButton, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import 'react-dropzone-uploader/dist/styles.css'
import CustomChip from '../../../../shared/components/CustomChip'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import SubHeader from '../../../../shared/styles/Subheader'
import NewsModal from '../components/modal/NewsModal'
import { ActionButtons } from '../components/table/ActionButtons'
import { DeleteNewsDialog } from '../components/table/DeleteNewsDialog'
import NewsNotifications from '../components/table/NewsNotifications'
import { NewsTable } from '../components/table/NewsTable'
import { useNewsFilters } from '../hooks/useNewsFilters'
import { useTableTools } from '../hooks/useTableTools'

function News() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const { news, showForm, loading, globalBrandId, optionsData } = useNewsFilters()
  const {
    handleEditNews,
    handleViewNews,
    handleOpenDeleteDialog,
    handleClickHighlight,
    handleCreateNews,
    handleClickSetOptions,
    setOpenDeleteNews,
    openDeleteNews,
    newsSelected
  } = useTableTools()

  return (
    <>
      {showForm && <NewsModal />}
      <Header title={t('news')} />
      <SubHeader />

      <Container maxWidth="lg">
        <Box sx={{ display: showForm ? 'none' : 'block' }}>
          <Box
            mt={isMobile ? 2 : 6}
            sx={{
              gap: 2,
              display: 'flex',
              flexDirection: isMobile ? 'column-reverse' : 'column'
            }}
          >
            <Box display="flex" justifyContent="center">
              <Typography variant="h5" align="center">
                {t('all')}
              </Typography>
              <Tooltip
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                arrow
                title={
                  <Box>
                    <Typography variant="body2">{t('status')}:</Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <CustomChip size="small" color={'primary'} />
                      <Typography variant="caption">{t('active')}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <CustomChip size="small" color={'secondary'} />
                      <Typography variant="caption">{t('inactive')}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <CustomChip size="small" color={'grey'} />
                      <Typography variant="caption">{t('draft')}</Typography>
                    </Box>
                  </Box>
                }
              >
                <IconButton>
                  <InfoOutlined sx={{ color: '#8F99A3' }} fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <Box>
              <ActionButtons handleClickSetOptions={handleClickSetOptions} handleCreateNews={handleCreateNews} optionsData={optionsData} />
            </Box>
          </Box>

          {news.length === 0 && !loading ? (
            <NotFilter subsection={null} handleClearFilters={handleClickSetOptions} />
          ) : (
            <Box mt={3}>
              <div className="table_custom">
                <NewsTable
                  news={news}
                  isMobile={isMobile}
                  globalBrandId={globalBrandId}
                  onView={handleViewNews}
                  onDelete={handleOpenDeleteDialog}
                  onEdit={handleEditNews}
                  onHighlight={handleClickHighlight}
                  loading={loading}
                />
              </div>
            </Box>
          )}
        </Box>
        <DeleteNewsDialog open={openDeleteNews} newsSelected={newsSelected} onClose={() => setOpenDeleteNews(!openDeleteNews)} />

        <NewsNotifications />
      </Container>
    </>
  )
}

export default News
